
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

import {
    LayoutDashboard,
    ClipboardPlus,
    Package,
    Warehouse,
    Truck,
    FileText,
    Settings,
    Snowflake,
    ReceiptText,
    X
} from "lucide-react";

import { useAuth } from "../context/AuthContext";
import "./sidebar.css";

function Sidebar({ onNavigate, onClose }) {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const menuItems = [
        {
            name: "Dashboard",
            path: "/dashboard",
            icon: LayoutDashboard
        },
        {
            name: "Goods Received",
            path: "/goods-received",
            icon: ClipboardPlus
        },
        {
            name: "Inventory",
            path: "/inventory",
            icon: Package
        },
        {
            name: "Chambers",
            path: "/chambers",
            icon: Warehouse
        },
        {
            name: "Delivery",
            path: "/delivery",
            icon: Truck
        },
        {
            name: "Delivery Challans",
            path: "/delivery-challans",
            icon: FileText
        },
        {
            name: "Customer Charges",
            path: "/customer-charges",
            icon: ReceiptText
        },
        {
            name: "Cash Vouchers",
            path: "/cash-vouchers",
            icon: ReceiptText
        },
        {
            name: "Settings",
            path: "/settings",
            icon: Settings
        }
    ];

    const handleLogout = () => {
        const confirmed = window.confirm(
            "Are you sure you want to logout?"
        );

        if (!confirmed) return;

        // Close the drawer before logging out.
        if (onClose) onClose();

        logout();

        navigate("/login", { replace: true });
    };

    const handleNavigation = () => {
        // Close the mobile drawer after choosing a page.
        if (onNavigate) onNavigate();
    };

    return (
        <aside className="sidebar">
            {/* LOGO */}
            <div className="sidebar-logo">
                <div className="logo-icon">
                    <Snowflake size={23} />
                </div>

                <div className="logo-text">
                    <h2>Bhimashankar</h2>
                    <span>Cold Storage ERP</span>
                </div>

                {/* Close button for mobile */}
                <button
                    type="button"
                    className="sidebar-mobile-close"
                    aria-label="Close navigation menu"
                    onClick={onClose}
                >
                    <X size={22} />
                </button>
            </div>

            {/* NAVIGATION */}
            <nav className="sidebar-menu" aria-label="ERP navigation">
                {menuItems.map((item) => {
                    const Icon = item.icon;

                    return (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={handleNavigation}
                            className={({ isActive }) =>
                                isActive
                                    ? "menu-link active"
                                    : "menu-link"
                            }
                        >
                            <Icon size={19} />

                            <span>{item.name}</span>
                        </NavLink>
                    );
                })}
            </nav>

            {/* LOGOUT */}
            <div className="sidebar-footer">
                <button
                    type="button"
                    className="sidebar-logout"
                    onClick={handleLogout}
                >
                    Logout
                </button>
            </div>
        </aside>
    );
}

export default Sidebar;
